import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import moment from "moment";
import { useSelector } from "react-redux";
import AdminDiamondReportService from "../../../services/reports-AdminDiamond-service";
import AdminDiamondShapeIndComp from "../../AdminChartsGroup/AdminDiamondShapeIndComp";
import {
  DatePicker,
  Select,
  Space,
  Spin,
  Table,
  Tooltip as AntdToolTip,
  Button,
} from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logoImg from "../../../assets/images/logo-img.png";
import { chartColors } from "../../reports/colors";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
const { RangePicker } = DatePicker;

const DiamondShapeReport = () => {
  const { t } = useTranslation();

  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  const [colorData, setColorData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [TableShapeValue, setTableShapeValue] = useState("");
  const [TableClarityValue, setTableClarityValue] = useState("");
  const [TableCutGradeValue, setTableCutGradeValue] = useState("");
  const [TableColorValue, setTableColorValue] = useState("");
  const [TableSizeValue, setTableSizeValue] = useState("");
  const [TableCertificateValue, setTableCertificateValue] = useState("");
  const [CSVLoading, setCSVLoading] = useState(false);
  const [PDFLoading, setPDFLoading] = useState(false);
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);

  const [forDealer, setForDealer] = useState("");
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [TotalDiamondRecords, setTotalDiamondRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortOrderCol, setsortOrderCol] = useState("date");
  const [sortOrderType, setsortOrderType] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [DiamondShapeTableList, setDiamondShapeTableList] = useState([]);
  const [key, setKey] = useState(true);
  const [paginationPage, setPaginationPage] = useState(1);

  const { Option } = Select;

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  // Handle chart click - refresh table when shape value changes
  useEffect(() => {
    if (TableShapeValue && dealerId && forDealer) {
      handleGetDiamondShapeList(
        dealerId,
        forDealer,
        1,
        pageSize,
        sortOrderCol,
        sortOrderType,
        TableShapeValue
      );
    }
  }, [TableShapeValue]);

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      AdminDiamondReportService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var forDealer = responseData.forDealer;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            handleLoadChartReports(id, forDealer);
            handleGetDiamondShapeList(
              id,
              forDealer,
              pageNo,
              pageSize,
              sortOrderCol,
              sortOrderType
            );
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: globalDiamonds.retailerIds.toString(),
        vendorIds: globalDiamonds.vendorIds.toString(),
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        type: "Global",
        reportName: "Cut",
      };
      setLoadChartReportsLoading(true);

      AdminDiamondReportService.LoadChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TotalDiamondClicks =
            responseData.TotalDiamondClicks[0].TotalClickCnt;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalDiamondClicks(TotalDiamondClicks);
              setKey(!key);
            }
          } else {
            setTotalDiamondClicks([]);
          }
        })
        .catch((error) => {
          setLoadChartReportsLoading(false);
          setTotalDiamondClicks([]);
        });
    } catch (error) {
      setLoadChartReportsLoading(false);
      setTotalDiamondClicks([]);
    }
  };

  const handleGetDiamondShapeList = (
    dealerId,
    forDealer,
    pageNo,
    pageSize,
    sortOrderCol,
    sortOrderType,
    TableShapeValue
  ) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue ? TableShapeValue : "",
      color: TableColorValue,
      size: TableSizeValue,
      certificate: TableCertificateValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      reporttype: "Global",
      reportName: "Shape",
    };
    setLoading(true);
    setTableShapeValue(TableShapeValue);
    AdminDiamondReportService.GetAllChartForTableList(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setDiamondShapeTableList(
            responseData.getDiamondReportForTableChartAll20resp
          );
          setTotalDiamondRecords(responseData.totalRows);
          setKey(!key);
        } else {
          setDiamondShapeTableList([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => setLoading(false));
  };


  const handleDownloadCSVReports = (

  ) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue ? TableShapeValue : "",
      color: TableColorValue,
      size: TableSizeValue,
      certificate: TableCertificateValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      reporttype: "Global",
      reportName: "Shape",
    };
    setCSVLoading(true);
    setTableShapeValue(TableShapeValue);
    AdminDiamondReportService.GetCSVChartForTableList(inputData)
      .then((response) => {

        setCSVLoading(false);
        var fileName =
          "DiamondShape_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".csv";
        BlobToDownloadFile(response.data, fileName);
      })
      .catch((error) => {
        setCSVLoading(false);
      });
  };

  const handleDownloadPDFReports = () => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue ? TableShapeValue : "",
      color: TableColorValue,
      size: TableSizeValue,
      certificate: TableCertificateValue,
      pageNumber: pageNo,
      pageSize: pageSize,
      sortOrderCol: sortOrderCol || "date",
      sortOrderType: sortOrderType || "DESC",
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      reporttype: "Global",
      reportName: "Shape",
    };
    setPDFLoading(true);
    AdminDiamondReportService.GetPDFChartForTableList(inputData)
      .then((response) => {
        setPDFLoading(false);
        var fileName =
          "DiamondShape_Report" +
          new Date().toJSON().slice(0, 10).split("-").reverse().join("/") +
          ".pdf";
        BlobToDownloadFile(response.data, fileName, "pdf");
      })
      .catch((error) => {
        setPDFLoading(false);
      });
  };

  function handleOnChange(e, isSelect, name) {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  }

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setsortOrderType(type);
      setsortOrderCol(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setsortOrderType(type);
      setsortOrderCol(column);
    } else {
      type = "DESC";
      column = "date";
      setsortOrderCol(column);
      setsortOrderType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetDiamondShapeList(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type,
      TableShapeValue
    );
  };

  const options = {
     legend: { position: "none" },
    bar: { groupWidth: "40%" },
    chartArea: { left: 40, top: 80, bottom: 70, width: "90%", height: "80%" },
    hAxis: {
      title: "Shape",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    vAxis: {
      title: "Searches",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 16,
        bold: true,
        color: "#000",
      },
    },
  };

  const handleDownloadPieChart = async () => {
    try {
      // Step 1: Prepare enhanced chart options for export
      const pdfChartOptions = {
        ...options,
        width: 1800, // use full width for better readability
        height: 950,
        chartArea: {
          left: 80,
          top: 140, // more space for legend above
          bottom: 160,
          width: "100%",
          height: "100%",
        },
        hAxis: {
          ...options.hAxis,
          slantedText: true,
          slantedTextAngle: 45,
          textStyle: { fontSize: 16, color: "#333" },
        },
        vAxis: {
          ...options.vAxis,
          textStyle: { fontSize: 15, color: "#333" },
        },
        annotations: {
          ...options.annotations,
          textStyle: { fontSize: 15, bold: true, color: "#000" },
        },
      };

      // Step 2: Create hidden container
      const hiddenContainer = document.createElement("div");
      hiddenContainer.id = "pdf-temp-chart";
      hiddenContainer.style.position = "absolute";
      hiddenContainer.style.left = "-9999px";
      hiddenContainer.style.top = "0";
      hiddenContainer.style.width = "1800px";
      hiddenContainer.style.background = "#fff";
      hiddenContainer.style.padding = "20px";
      document.body.appendChild(hiddenContainer);

      // Step 3: Build custom legend (larger + full width)
      const legendDiv = document.createElement("div");
      legendDiv.style.display = "flex";
      legendDiv.style.flexWrap = "wrap";
      legendDiv.style.justifyContent = "space-evenly"; // evenly spaced full width
      legendDiv.style.marginBottom = "20px";
      legendDiv.style.fontFamily = "Arial, sans-serif";
      legendDiv.style.width = "100%";

      chartData.slice(1).forEach((label, index) => {
        const item = document.createElement("div");
        item.style.display = "flex";
        item.style.alignItems = "center";
        item.style.margin = "8px 16px";
        item.style.fontSize = "18px"; // larger font
        item.style.fontWeight = "bold";
        item.style.whiteSpace = "nowrap";

        const colorBox = document.createElement("div");
        colorBox.style.width = "18px";
        colorBox.style.height = "18px";
        colorBox.style.backgroundColor = colorData[index];
        colorBox.style.marginRight = "8px";
        colorBox.style.border = "1px solid #aaa";
        colorBox.style.borderRadius = "3px";

        const textNode = document.createTextNode(
          `${label[0]} (${label[1]})`
        );

        item.appendChild(colorBox);
        item.appendChild(textNode);
        legendDiv.appendChild(item);
      });

      hiddenContainer.appendChild(legendDiv);

      // Step 4: Add chart container
      const chartDiv = document.createElement("div");
      chartDiv.style.width = "1800px";
      chartDiv.style.height = "900px";
      hiddenContainer.appendChild(chartDiv);

      // Step 5: Draw chart
      const tempChart = new window.google.visualization.ColumnChart(chartDiv);
      const dataTable = window.google.visualization.arrayToDataTable(chartData);
      await new Promise((resolve) => {
        window.google.visualization.events.addListener(tempChart, "ready", resolve);
        tempChart.draw(dataTable, pdfChartOptions);
      });

      // Step 6: Capture legend + chart together
      const canvas = await html2canvas(hiddenContainer, {
        useCORS: true,
        scale: 2.8,
        logging: false,
      });
      const imgData = canvas.toDataURL("image/png");

      // Step 7: Clean up
      document.body.removeChild(hiddenContainer);

      // Step 8: Create PDF
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const headerHeight = 14;
      const footerHeight = 10;
      const infoBlockHeight = 15;
      const availableHeight =
        pageHeight - headerHeight - footerHeight - infoBlockHeight - 6;

      // Header
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, 0, pageWidth, headerHeight, "F");
      try {
        pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
      } catch { }

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.setTextColor(255, 255, 255);
      pdf.text("DIAMOND SHAPE REPORT", pageWidth - margin, 11, {
        align: "right",
      });

      // Info line
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;

      // Chart + Legend image
      const imgRatio = canvas.width / canvas.height;
      let imgWidthMM = pageWidth - margin * 3;
      let imgHeightMM = imgWidthMM / imgRatio;
      if (imgHeightMM > availableHeight) {
        imgHeightMM = availableHeight;
        imgWidthMM = imgHeightMM * imgRatio;
      }

      const xPos = margin;
      const yPos = currentY; 
      pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");

      // Footer
      pdf.setFillColor(31, 38, 62);
      pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(8);
      const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
        "MMM DD, YYYY h:mm A"
      )}`;
      pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
        align: "center",
      });

      // --- WATERMARK ---
      const watermarkText = "JewelCloud";
      pdf.setFontSize(90);
      pdf.setFont(undefined, "bolditalic");
      pdf.setTextColor(102, 102, 102);

      pdf.saveGraphicsState();
      pdf.setGState(pdf.GState({ opacity: 0.1 }));

      const centerX = pageWidth / 2;
      const centerY = pageHeight / 2;

      const textWidth = pdf.getTextWidth(watermarkText);
      const textHeight =
        pdf.internal.getFontSize() / pdf.internal.scaleFactor;

      const angleRad = (45 * Math.PI) / 180;
      const rotatedWidth =
        textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
      const rotatedHeight =
        textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);

      const xPosWatermark = centerX - rotatedWidth / 2;
      const yPosWatermark = centerY + rotatedHeight / 4 + 40;

      pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });

      pdf.restoreGraphicsState();

      pdf.save("Diamond-Shape-Report.pdf");
    } catch (err) {
      console.error("Error generating PDF:", err);
    }
  };

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Diamond Shape Report")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>

              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                showSearch
                className="border__grey"
                placeholder={t("All")}
                optionFilterProp="children"
                name="SelectedDiamondValue"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All"> {t("All")} </Option>
                <Option value="Mined"> {t("Mined Diamond")} </Option>
                <Option value="Lab"> {t("Lab Grown Diamond")} </Option>
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <button
                className="primary-btn mobile-mt-0"
                style={{ marginTop: 25 }}
                onClick={handleApplyFilter}
              >
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>
          {DiamondShapeTableList && DiamondShapeTableList.length > 0 && (
            <div className="col-lg-12 col-md-6 mt-4">
              <div className="input__block">
                <label>
                  {/* <b> {t("Total Clicks")} : 7</b> */}
                  <Spin spinning={LoadChartReportsLoading} size="small">
                    <b>
                      {" "}
                      {t("Total Clicks")} :{" "}
                      {TotalDiamondClicks ? TotalDiamondClicks : 0}
                    </b>
                  </Spin>
                </label>
              </div>
            </div>
          )}
          <div className="">
            <div className="chart__section" id="pdf-content">
              {forDealer && (
                <AdminDiamondShapeIndComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                  pageNo={pageNo}
                  pageSize={pageSize}
                  sortOrderCol={sortOrderCol}
                  sortOrderType={sortOrderType}
                  setPageNo={setPageNo}
                  handleGetDiamondShapeList={handleGetDiamondShapeList}
                  setColorData={setColorData}
                  colorData={colorData}
                  setChartData={setChartData}
                  chartData={chartData}
                  setTableShapeValue={setTableShapeValue}
                  setPaginationPage={setPaginationPage}
                />
              )}
            </div>
          </div>
          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
            {forDealer && (
              <>
                <Button
                  className="primary-btn mb-2 mb-lg-0 mr-2"
                  onClick={handleDownloadPieChart}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download Chart")}
                </Button>
                <Button
                  className="primary-btn mb-2 mb-lg-0 mr-2"
                  onClick={handleDownloadPDFReports}
                  loading={PDFLoading}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download PDF")}
                </Button>
                <Button
                  className="primary-btn"
                  onClick={handleDownloadCSVReports}
                  loading={CSVLoading}
                >
                  {" "}
                  <i className="fa fa-download"></i> {t("Download CSV")}
                </Button>
              </>
            )}
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
                  scroll={{ x: 1200, y: "calc(100vh - 340px)" }}
              columns={[
                {
                  title: (
                    <AntdToolTip title={t("UsersIPAddress")}>
                      {t("UsersIPAddress")}
                    </AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "usersIPAddress",

                  sorter: (a, b) =>
                    a.usersIPAddress.localeCompare(b.usersIPAddress),
                  render: (item, row) => {
                    return (
                      <div>
                        {row.usersIPAddress === "::1" ? (
                          <span>-</span>
                        ) : (
                          <span>{row.usersIPAddress}</span>
                        )}
                      </div>
                    );
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Date")}>{t("Date")}</AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "date",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => a.date.localeCompare(b.date),
                  render: (row, item) => {
                    //

                    if (Object.keys(item.date).length !== 0) {
                      return (
                        <React.Fragment>
                          <span>
                            {moment(item.date).format("MM-DD-YYYY, hh:mm:ss A")}
                          </span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <AntdToolTip title={t("Shape")}>{t("Shape")}</AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "shape",
                  sorter: (a, b) => a.shape.localeCompare(b.shape),
                },
                {
                  title: (
                    <AntdToolTip title={t("Size")}>{t("Size")}</AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "size",
                  sorter: (a, b) => a.size.localeCompare(b.size),
                },
                {
                  title: (
                    <AntdToolTip title={t("Color")}>{t("Color")}</AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "color",
                  sorter: (a, b) => a.color.localeCompare(b.color),
                },
                {
                  title: <AntdToolTip title={t("Cut")}>{t("Cut")}</AntdToolTip>,
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "cutGrade",
                  sorter: (a, b) => a.cutGrade.localeCompare(b.cutGrade),
                },
                {
                  title: (
                    <AntdToolTip title={t("Clarity")}>
                      {t("Clarity")}
                    </AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "clarity",
                  sorter: (a, b) => a.clarity.localeCompare(b.clarity),
                },
                {
                  title: (
                    <AntdToolTip title={t("Certificates")}>
                      {t("Certificates")}
                    </AntdToolTip>
                  ),
                  ellipsis: true,
                  showSorterTooltip: false,
                  dataIndex: "certificate",
                  sorter: (a, b) => a.certificate.localeCompare(b.certificate),
                },
                {
                  title: (
                    <AntdToolTip title={t("Retail Price")}>
                      {t("Retail Price")}
                    </AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  sorter: (a, b) => a.retailPrice.localeCompare(b.retailPrice),
                  render: (retailPrice) => (
                    <AntdToolTip title={retailPrice}>
                      <span>{retailPrice}</span>
                    </AntdToolTip>
                  ),
                },
                {
                  title: (
                    <AntdToolTip title={t("Cost")}>{t("Cost")}</AntdToolTip>
                  ),
                  showSorterTooltip: false,
                  ellipsis: true,
                  dataIndex: "cost",
                  sorter: (a, b) => a.cost.localeCompare(b.cost),
                  render: (cost) => (
                    <AntdToolTip title={cost}>
                      <span>{cost}</span>
                    </AntdToolTip>
                  ),
                },
              ]}
              loading={loading}
              dataSource={DiamondShapeTableList}
              pagination={{
                size: "small",
                total: TotalDiamondRecords,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
                current: paginationPage,
                onChange: (pageNum) => setPaginationPage(pageNum),
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondShapeReport;
